import React from 'react';
import styled from 'styled-components';
import {
	getBodyRelatedObjectsHeaders,
	getBodyRelatedObjectsPlaceHolder,
	getConfigurationForEntity
} from '../printViewConfig';
import Utility from '../../../../../util/utilityfunctions';
import {GetCardTypeForBody} from '../../../../../util/utils';

function PrintViewSpecialBody(props) {
	const {body} = props;
	const formBodyTypeId = body.bodyTypeId;

	const formBodyBorder = GetCardTypeForBody(body);

	let headers = <></>;
	let bodyRelatedObjects = body.bodyRelatedObjects;

	const mainKey = `bro-${body.id}-main`;

	// Get body's header configuration
	const headersList = getBodyRelatedObjectsHeaders(
		formBodyTypeId,
		body.bodyRelatedObjects && body.bodyRelatedObjects[0] && body.bodyRelatedObjects[0].entityId
	);

	const headerCount = headersList.length;

	headers = headersList?.map((header, index) => {
		let headerClassName = 'entity-name';
		if (headerCount === 1) {
			headerClassName = 'entity-name single-column';
		} else if (index === 0) {
			headerClassName = 'entity-name';
		} else {
			headerClassName = 'entity-data';
		}
		let headerKey = `${mainKey}-header-${index}`;
		return (
			<section key={headerKey} className={`header-${headerClassName}`}>
				{header.label}
			</section>
		);
	});

	return (
		<StyledPrintViewSpecialBody key={mainKey} className={`StyledPrintViewSpecialBody ${formBodyBorder}`}>
			<section className="bro-title">{Utility.getHtmlTextElement(body.name, true)}</section>
			<section className="bro-content">
				<section className="bro-content-headers">{headers}</section>
				<section className="bro-content-data">
					{bodyRelatedObjects && bodyRelatedObjects.length > 0 ? (
						bodyRelatedObjects.sort(Utility.sortByMultipleKey('entityName')).map((object) => {
							const innerProps = {
								isTopLevel: true,
								formBodyTypeId
							};
							return getConfigurationForEntity(object.entityId).render(object, innerProps);
						})
					) : (
						<section className="bro-content-placeholder-text">
							{getBodyRelatedObjectsPlaceHolder(formBodyTypeId)}
						</section>
					)}
				</section>
			</section>
		</StyledPrintViewSpecialBody>
	);
}

const StyledPrintViewSpecialBody = styled.section`
	font-size: var(--px-14);
	.bro-title {
		font-size: var(--px-14);
		margin-bottom: var(--px-10);
	}
	.bro-content {
		font-size: var(--px-14);
		.bro-content-headers {
			display: flex;
			font-weight: bold;
			.header-entity-name {
				width: 80%;
				padding-right: var(--px-10);
			}
		}
		.bro-content-data {
		}
	}
	.CountWrapper {
		margin-left: var(--px-10);
		padding: var(--px-1) var(--px-5);
		border-radius: var(--px-10);
		background-color: var(--neutrals-00white) !important;
		font-size: var(--px-12);
		font-weight: 400;
		border: var(--px-1) solid var(--neutrals-900) !important;
		line-height: normal;
		height: var(--px-20);
	}
`;

export default PrintViewSpecialBody;
